import * as React from 'react';

var _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgGoogleAuthenticator = function SvgGoogleAuthenticator(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_1576_1146)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#1A73E8",
        d: "M120 60.318c0 5.583-4.526 10.11-10.109 10.11H75l-15-30.33 16.19-28.042C78.982 7.22 85.164 5.565 90 8.356H90c4.835 2.792 6.492 8.975 3.7 13.81L77.511 50.21h32.38c5.583 0 10.109 4.526 10.109 10.108"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EA4335",
        d: "m90 112.28-.001.001c-4.835 2.791-11.017 1.135-13.809-3.7L60 80.539l-16.19 28.042c-2.792 4.835-8.974 6.491-13.809 3.7L30 112.28c-4.835-2.791-6.492-8.974-3.7-13.809l16.19-28.044L60 69.775l17.51.652 16.191 28.044c2.792 4.835 1.135 11.018-3.7 13.809"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FBBC04",
        d: "m60 40.098-4.565 12.394-12.946-2.282L26.3 22.166c-2.791-4.835-1.135-11.018 3.7-13.81h.002c4.835-2.791 11.017-1.135 13.809 3.7z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#34A853",
        d: "M57.391 50.21 45.652 70.427H10.11C4.526 70.427 0 65.901 0 60.318 0 54.737 4.526 50.21 10.109 50.21z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#185DB7",
        d: "M77.51 70.427H42.49L60 40.097z"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_1576_1146"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 .035h120v120H0z"
    })))));
};

export { SvgGoogleAuthenticator as ReactComponent };
//# sourceMappingURL=GoogleAuthenticator.svg.es.js.map
